'use strict';
var monitoringInformationTpl = require('../views/information.html');

module.exports = /*@ngInject*/ function monitoringFilters() {
    return {
        restrict: 'E',
        template: monitoringInformationTpl,
        controller: 'InformationMonitoringViewController',
        controllerAs: 'vm',
        scope: {},
        bindToController: true // because the scope is isolated
    };

}
